import React from 'react';
import ReactDOM from 'react-dom';
import Auth from '@aws-amplify/auth';
import App from './containers/index';
import { pdfjs } from 'react-pdf';
import { AuthenticationProvider } from './containers/authentication/AuthenticationContext';
import { CONFIG } from './config/Config';
import 'moment/locale/nl-be';
import './index.css';
import 'pdfjs-dist/web/pdf_viewer.css';
import './style/Hero.css';
import './style/PdfHighlighter.css';
import './style/MouseSelection.css';
import '../src/lib/i18n/i18n';

const { cognito } = CONFIG;
Auth.configure(cognito);

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

ReactDOM.render(
  <AuthenticationProvider>
    <App />
  </AuthenticationProvider>,
  document.getElementById('root')
);
